module.exports = __webpack_public_path__ + "img/astro_off.5ed12cf5.svg";